import { Container, Stack, Title, Text, Divider, useMantineTheme } from "@mantine/core";
import React from "react";
import Seo from "../seo/Seo";

function TermsAndService() {
  const theme = useMantineTheme();
  return (
    <Container size="md" py={40}>
      <Stack gap={30}>
        <Seo
          title="Terms of Service | SubjectBuddy"
          description="Read the SubjectBuddy terms of service for academic mentoring, tutoring, project guidance, and student support."
          path="/terms-of-service"
        />
        <Title
          order={1}
          style={{
            color: theme.colors.green[7],
            fontFamily: theme.headings.fontFamily,
            fontWeight: 800,
            textAlign: "center",
          }}
        >
          Terms & Services
        </Title>
        <Text size="md" c="dimmed">
          Last updated: July 4, 2025
        </Text>
        <Divider my={10} />
        <Title
          order={2}
          style={{
            color: theme.colors.green[8],
            fontWeight: 700,
            fontSize: 22,
          }}
        >
          Our Services
        </Title>
        <Text>
          <ul style={{ margin: 0, paddingLeft: 24 }}>
            <li>
              <b>Academic Guidance:</b> Personalized help in understanding
              assignments, projects, and practicals with the support of mentors.
              We don’t just help — we explain, guide, and make you capable.
            </li>
            <li>
              <b>Project Mentorship:</b> Real-world project guidance in
              software, electronics, data science, and more — tailored for
              academic excellence, not just submissions.
            </li>
            <li>
              <b>Lab & Practical Prep:</b> Be ready with conceptual clarity and
              hands-on mentoring for labs, vivas, and practical exams.
            </li>
            <li>
              <b>Live Doubt-Solving:</b> Connect 1-on-1 with expert mentors for
              real-time support and understanding during your academic sessions.
            </li>
          </ul>
        </Text>
        <Divider my={20} />
        <Title
          order={2}
          style={{
            color: theme.colors.red[7],
            fontFamily: theme.headings.fontFamily,
            fontWeight: 700,
            textAlign: "center",
          }}
        >
          Disclaimer & Safety Note
        </Title>
        <Text>
          SubjectBuddy is a mentorship platform. We do not create, write, or
          submit work on behalf of students. Our role is to guide, support, and
          mentor students to understand their academic tasks.
          <br />
          <br />
          All actions taken using SubjectBuddy’s guidance are the responsibility
          of the user. SubjectBuddy is not liable for any academic,
          institutional, or disciplinary consequences arising from misuse of the
          mentorship or guidance provided. Users are expected to comply with
          their own institution’s academic integrity policies.
        </Text>
      </Stack>
    </Container>
  );
}

export default TermsAndService;
